import { css, type Theme } from "@emotion/react";
import type { FC, FormEventHandler, PropsWithChildren } from "react";

interface OTPFormProps {
  onSubmit: FormEventHandler<HTMLFormElement>;
}

/**
 * Padding fixes Pedal input components focus border cut off by iframe.
 * Hard-coded to 3px to match the Pedal focus state box-shadow value.
 * @see https://github.com/turo/design-system-frontend-core/blob/5f718d6b402d8de5671da155c7110d351f3f0831/src/shared-styles/Shared.styles.ts#L16-L19
 */
const otpFormStyles = (theme: Theme) => css`
  padding: 0 3px 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.gutters.gutter_16};
`;

export const OTPForm: FC<PropsWithChildren<OTPFormProps>> = ({
  children,
  onSubmit,
}) => {
  return (
    <form css={otpFormStyles} noValidate onSubmit={onSubmit}>
      {children}
    </form>
  );
};
